import { render } from "./EnvioMagicLinksEvento.vue?vue&type=template&id=f4773bb0&scoped=true"
import script from "./EnvioMagicLinksEvento.vue?vue&type=script&lang=js"
export * from "./EnvioMagicLinksEvento.vue?vue&type=script&lang=js"

import "./EnvioMagicLinksEvento.vue?vue&type=style&index=0&id=f4773bb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4773bb0"]])

export default __exports__